import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import * as Sentry from "@sentry/react";
import "@/index.css";
import App from "@/App";
import { initMetaPixel } from "@/lib/metaPixel";

// Optional error monitoring. No-op if REACT_APP_SENTRY_DSN isn't set —
// safe to leave unconfigured in local dev, recommended for production.
if (process.env.REACT_APP_SENTRY_DSN) {
    Sentry.init({
        dsn: process.env.REACT_APP_SENTRY_DSN,
        environment: process.env.NODE_ENV,
        tracesSampleRate: 0.2,
    });
}

// Optional Meta (Facebook/Instagram) ads pixel. No-op if
// REACT_APP_META_PIXEL_ID isn't set.
initMetaPixel();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Sentry.ErrorBoundary fallback={<ErrorFallback />}>
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </Sentry.ErrorBoundary>
  </React.StrictMode>,
);

function ErrorFallback() {
    return (
        <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", fontFamily: "sans-serif", flexDirection: "column", gap: "12px" }}>
            <p>Something went wrong. Please refresh the page.</p>
            <button onClick={() => window.location.reload()} style={{ padding: "8px 16px", cursor: "pointer" }}>
                Reload
            </button>
        </div>
    );
}

